import React from "react";

export const truncateText = (html, max = 30) => {
  if (!html) return "";

  const div = document.createElement("div");
  div.innerHTML = html;

  const text = div.textContent || div.innerText || "";

  const truncated =
    text.length > max ? text.substring(0, max) + "..." : text;

  return (
    <p
      className="max-w-500-px text-truncate"
      style={{ maxWidth: "400px", cursor: "pointer" }}
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={text}
    >
      {truncated}
    </p>
  );
};

export const sanitizeValue = (name, value) => {
  if (typeof value !== "string") return value;

  let sanitized = value.trim();

  sanitized = sanitized.replace(/\s{2,}/g, " ");

  return sanitized;
};

export const formatDateTime = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const month = months[date.getMonth()];
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12;

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return "";

  const datePart = dateString.split("T")[0];

  const [year, month, day] = datePart.split("-");

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  return `${day}-${months[Number(month) - 1]}-${year}`;
};

export const formatTime = (timeString) => {
  if (!timeString) return "";

  const [hoursStr, minutes] = timeString.split(":");
  let hours = Number(hoursStr);

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${hours}:${minutes} ${ampm}`;
};

export const getDeviceInfo = () => {
  const ua = navigator.userAgent;

  let device = "Desktop";
  if (/Mobi|Android/i.test(ua)) device = "Mobile";
  if (/Tablet|iPad/i.test(ua)) device = "Tablet";

  let browser = "Unknown";
  if (ua.includes("Chrome")) browser = "Chrome";
  else if (ua.includes("Firefox")) browser = "Firefox";
  else if (ua.includes("Safari")) browser = "Safari";
  else if (ua.includes("Edge")) browser = "Edge";

  return `${device} - ${browser}`;
};

export const getImageUrlHelper = (file) => {
  const BASE_URL = process.env.REACT_APP_API_URL;

  // if (!file) {
  //   return "/assets/images/no-image.png";
  // }

  if (!file) return null;

  const cleanFile = file.replace(/^\/+/, "");

  const ext = cleanFile.split(".").pop()?.toLowerCase();

  if (ext === "pdf") {
    return "/assets/images/pdf-image.png";
  }

  if (ext === "ppt" || ext === "pptx") {
    return "/assets/images/ppt-image.png";
  }

  return `${BASE_URL}/${cleanFile}`;
};

export const getStatusClass = (status) => {
  switch (status) {
    case "APPROVED":
      return "bg-success text-white";

    case "PENDING":
      return "bg-warning text-dark";

    case "CANCELLED":
      return "bg-danger text-white";

    default:
      return "bg-secondary text-white";
  }
};